import { render, staticRenderFns } from "./ClinicOrderList.vue?vue&type=template&id=5f335836&scoped=true&"
import script from "./ClinicOrderList.vue?vue&type=script&lang=js&"
export * from "./ClinicOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f335836",
  null
  
)

export default component.exports